import Axios from 'axios'
import store from '../store'
import strings from '@/strings'
import utils from '@/utils/utils.js'

export default {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getAdministrators () {
    return Axios.get(`api/v1/clients/${this.getClientIdDesk4me()}/administrators/${utils.getLastPathUrl()}`)
  },
  saveAdministrator (body) {
    return Axios.post(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/administrators/${utils.getLastPathUrl()}`, body)
  },
  editAdministrator (body) {
    return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/administrators/${utils.getLastPathUrl()}`, body)
  },
  removeAdministrator (email) {
    return Axios.delete(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/administrators/${utils.getLastPathUrl()}`, { data: { email: email } })
  }
}
